import AIButton from './AIButton';

export default AIButton;
export type { AIButtonProps, AIButtonShape, AIButtonSize, AIButtonVariant } from './AIButton';
